"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpectedError = exports.WorkflowKind = void 0;
var WorkflowKind;
(function (WorkflowKind) {
    WorkflowKind[WorkflowKind["SingleItem"] = 0] = "SingleItem";
    WorkflowKind[WorkflowKind["Reduce"] = 1] = "Reduce";
    WorkflowKind[WorkflowKind["Grid"] = 2] = "Grid";
    WorkflowKind[WorkflowKind["DynamicText"] = 3] = "DynamicText";
    WorkflowKind[WorkflowKind["Join"] = 4] = "Join";
    WorkflowKind[WorkflowKind["Generic"] = 5] = "Generic";
})(WorkflowKind = exports.WorkflowKind || (exports.WorkflowKind = {}));
/**
 * Specifying this exception in workflow actions done method will result in workflow execution reported as successful in AL metrics/monitoring.
 * AL team does not get notified of ExpectedError's unlike other reported errors which (if happen frequently enough) show up on our dashboards/monitoring.
 * If enough expected errors happen in a session the scenario (workflow) will be marked as yellow in scenario health metric for the session.
 */
var ExpectedError = /** @class */ (function (_super) {
    __extends(ExpectedError, _super);
    function ExpectedError(message) {
        if (message === void 0) { message = 'ExpectedError'; }
        var _this = _super.call(this, message) || this;
        _this.__proto__ = ExpectedError.prototype;
        return _this;
    }
    return ExpectedError;
}(Error));
exports.ExpectedError = ExpectedError;
//# sourceMappingURL=iworkflow.js.map